<div
  *ngIf="
    status === WhatsappCloudApiLoginEventEnum.CANCEL || status === WhatsappCloudApiLoginEventEnum.ERROR;
    else descriptionTemplate
  ">
  <div class="error">
    <mat-icon>cancel</mat-icon>
    <span translate="add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/cancelled/error"></span>
  </div>
  <p translate="add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/cancelled/description"></p>

  <div class="step-actions">
    <button mat-raised-button color="primary" (click)="clearStep()">{{ 'back' | translate }}</button>
  </div>

  <pre><code>{{whatsappCloudApiService.logs|json}}</code></pre>
</div>

<ng-template #descriptionTemplate>
  <div *ngIf="regions?.length">
    <p
      [innerHtml]="
        'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/review-localization' | translate
      "></p>
    <div class="review-localization">
      <app-select
        [appearance]="'outline'"
        labelKey="add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/hosting"
        [control]="hostingControl"
        [items]="regions">
      </app-select>
      <button
        mat-raised-button
        color="primary"
        [disabled]="hostingControl.invalid || hostingControl.value === form.value.localization"
        (click)="validNewLocalization()">
        {{ 'ok' | translate }}
      </button>
    </div>
    <hr />
  </div>

  <ng-container *ngIf="migration; else createAccountFlow">
    <p>Then, the next few steps will happen in a Facebook process.</p>
    <strong>Please connect <span class="highlight">now</span> with your Facebook login</strong>
    <p class="step-description-link">
      <a href="https://business.facebook.com/business/loginpage/" rel="noopener noreferrer" target="_blank">
        {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/migrate-link' | translate }}&nbsp;<mat-icon
          >open_in_new</mat-icon
        >
      </a>
    </p>

    <mat-checkbox [disableRipple]="true" [formControl]="$any(form.get('migrate').get('agreed'))">
      Note: <strong>That Facebook login should have administrator rights</strong> in the Meta Business Manager of your
      company <strong>AND</strong> (if they're not the same) in the Meta Business Manager currently hosting your phone
      number </mat-checkbox
    ><br />
  </ng-container>

  <div class="step-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="launchWhatsAppSignup()"
      [disabled]="(migration && form.invalid) || form.get('localization')?.invalid">
      <span class="launch-embedding-sign-up-btn">
        {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/next' | translate }}&nbsp;<img
          src="assets/img/site_icon/v2/facebook-2.svg" />
      </span>
    </button>
  </div>

  <p class="footer-description">
    <small>
      {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/footer' | translate }}
    </small>
  </p>
</ng-template>

<ng-template #createAccountFlow>
  <p [innerHTML]="'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/description' | translate"></p>
</ng-template>
